export const TypesExchange = {
    credit: 1,
    service: 2,
    yield: 3,
};